module.exports = __webpack_public_path__ + "img/ERROR404.1619108a.svg";